import React from 'react';

// Modal Sheet
import Sheet from 'react-modal-sheet';
import { useState } from 'react';

// Translation
import { useTranslation } from 'react-i18next';
import { Footerimg } from '../assets';
import { FaInfo } from 'react-icons/fa';

const DrinkMenu = ({portada, titulo, precio}) => {
    // Modal Sheet
    const [isOpen, setOpen] = useState(false);
    // Translation
    const { t } = useTranslation(); 

    return (
        <div className='flex drop-shadow-2xl bg-white rounded-2xl items-center justify-between mx-5'>
            <button onClick={() => setOpen(true)} className="shrink-0">
                <img src={portada} alt="portada" className='h-24 w-28 object-cover rounded-t-2xl' loading='lazy'/>
                <p className='text-xs bg-primary text-white rounded-b-2xl py-2 px-1 font-semibold flex justify-center'><FaInfo /></p>
            </button>
            <div className='flex flex-col mx-1 ml-3 grow'>
                <div><h1 className='text-neutral-600 font-bold mb-1'>{t(titulo)}</h1></div>
                <div><p className=' text-neutral-700 mt-2 text-sm'>$ {precio}.00</p></div>
            </div>
            
        <Sheet isOpen={isOpen} onClose={() => setOpen(false)}>
            <Sheet.Container>
                <Sheet.Header />
                    <Sheet.Content>
                        <div className='h-72 bg-cover rounded-t-2xl' style={{'backgroundImage':`url(${portada})`}}></div>
                        <div className='bg-white h-full rounded-t-2xl shadow-3xl -mt-5'>
                            <img src={Footerimg} alt="flores" className='w-full rounded-t-2xl'/>
                            <div className='mx-12 my-3'>
                                <h1 className='font-bold text-2xl text-slate-600'>{t(titulo)}</h1>
                                <h1 className='font-bold text-2xl text-slate-600 mt-5'>$ {t(precio)}.00</h1>
                            </div>
                        </div>
                    </Sheet.Content>
                </Sheet.Container>
            <Sheet.Backdrop />
        </Sheet>
    </div>
  )
}

export default DrinkMenu